/** @format */

import { Grid, IconButton, TextField, Typography } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import CloseIcon from '@material-ui/icons/Close';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'src/components/button';
import UploadField from 'src/components/upload/upload';
import { clearTicketError, getTicketDetail, updateTicket } from 'src/slices/tickets';
import { useDispatch, useSelector } from 'src/store';
import CancelCreateTicketModal from './cancel';
import ErrorCreateTicket from './error';
import SuccessUpdateTicket from './successUpdate';
import { MAX_NUMBER_OF_FILES } from 'src/constants';

const initPostData = {
  commentmessage: null,
  attachments: null,
  attachmentFileNames: null
};

export default function UpdateTicketModal({ open, onClose, incidentid, ticketnumber }) {
  const { t } = useTranslation();
  const [cancelModalOpen, setCancelModalOpen] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  const [postData, setPostData] = React.useState({ ...initPostData, incidentid });
  const [isValidate, setIsValidate] = React.useState(false);
  const [isFileValidate, setIsFileValidate] = React.useState(true); // true || string (message)
  const dispatch = useDispatch();
  const { userData } = useSelector(state => state.users);
  const [files, setFiles] = React.useState([]);
  const { tickets, updateTicketLoading, error } = useSelector(state => state.tickets);
  const [currentTicket, setCurrentTicket] = React.useState(null);
  const [fileKey, setFileKey] = React.useState(Math.random().toString(36));
  const [validations, setValidations] = React.useState({});

  React.useEffect(() => {
    if (error) setSuccess(false);
  }, [error]);

  React.useEffect(() => {
    setIsValidate(false);
    setIsFileValidate(true);
    if (postData.commentmessage) setIsValidate(true);
    if (validations.attachments) setIsFileValidate(validations.attachments);
  }, [postData, validations]);

  React.useEffect(() => {
    setPostData({ ...initPostData, incidentid });
    if (tickets && incidentid && !ticketnumber) {
      setCurrentTicket(tickets.find(t => t.incidentid === incidentid));
    }
    if (ticketnumber) {
      setCurrentTicket({
        ticketnumber
      });
    }
  }, [tickets, incidentid, ticketnumber]);

  const handleClose = () => {
    if (!updateTicketLoading) {
      if (success) closeUpdateTicket();
      else setCancelModalOpen(true);
    }
  };
  const closeUpdateTicket = () => {
    setFileKey(Math.random().toString(36));
    if (!updateTicketLoading) {
      onClose();
      setCancelModalOpen(false);
      // // avoid flash of layout
      setTimeout(() => {
        setSuccess(false);
        setFiles([]);
        dispatch(clearTicketError());
        // setCurrentTicket(null);
      }, 300);
    }
  };

  const updatePostData = (name, value) => {
    setPostData({ ...postData, [name]: value });
  };

  const handleSubmit = async () => {
    const patchPostData = {
      ...postData,
      commentmessage: `${userData.firstName} ${userData.lastName}: ` + postData.commentmessage
    };
    await dispatch(updateTicket(patchPostData));

    setPostData({ ...initPostData, incidentid });
    setSuccess(true);
    // setCurrentTicket(null);

    setTimeout(() => {
      dispatch(getTicketDetail(incidentid));
    }, 500);
  };

  return (
    <>
      <Dialog
        className={`ticket-modal-dialog`}
        fullWidth
        maxWidth="md"
        open={open}
        PaperProps={{
          style: {
            backgroundColor: '#fff',
            borderRadius: 10
          }
        }}
        onClose={handleClose}
        aria-labelledby="max-width-dialog-title"
      >
        <DialogActions>
          <IconButton onClick={handleClose}>
            <CloseIcon style={{ color: '#000' }} />
          </IconButton>
        </DialogActions>
        <DialogContent>
          {userData && currentTicket && (
            <div className="create-ticket-body">
              {error ? (
                <ErrorCreateTicket closeModal={closeUpdateTicket} />
              ) : success ? (
                <SuccessUpdateTicket ticketNumber={currentTicket.ticketnumber} closeModal={closeUpdateTicket} />
              ) : (
                <>
                  <Typography className="create-ticket-title">{t('Tickets.updateTicket')}</Typography>
                  <Typography className="create-ticket-id">
                    {t('Tickets.ticketNumber')} {currentTicket.ticketnumber}
                  </Typography>
                  <Grid container>
                    <Grid item xs={12}>
                      <Grid style={{ marginBottom: 20, marginTop: 20 }}>
                        <TextField
                          className="create-ticket-textarea"
                          multiline
                          fullWidth
                          label="Comment message *"
                          onChange={e => updatePostData('commentmessage', e.target.value)}
                          value={postData.commentmessage || ''}
                          variant="outlined"
                          minRows={8}
                          // helperText={postData.commentmessage ? `${postData.commentmessage.length}/1073741823` : ``}
                          inputProps={{ maxLength: 1073741823 }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>

                  <UploadField
                    error={typeof isFileValidate === 'string' ? isFileValidate : ''}
                    postData={postData}
                    setPostData={setPostData}
                    fileKey={fileKey}
                    setValidations={setValidations}
                    dataValue={postData.attachments}
                    accept={`application/pdf, image/*`}
                    type={`screenshot`}
                    filesLimit={MAX_NUMBER_OF_FILES}
                  />
                  <div className="create-ticket-btns">
                    <Button
                      disabled={!isValidate || updateTicketLoading || isFileValidate !== true}
                      borderOnly
                      onClick={handleSubmit}
                      additionalClassName="btn-submit"
                    >
                      {updateTicketLoading ? t('personalData.loading') : t('Tickets.submit')}
                    </Button>
                  </div>
                </>
              )}
            </div>
          )}
        </DialogContent>
      </Dialog>
      <CancelCreateTicketModal
        onClose={() => setCancelModalOpen(false)}
        open={cancelModalOpen}
        closeNewTicket={closeUpdateTicket}
      />
    </>
  );
}
